import React from 'react';
import ModalManager from 'components/Modals';
import Routes from '../Routes';
var App = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(Routes, null),
        React.createElement(ModalManager, null)));
};
export default App;
